
import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

export const TourDetailSkeleton: React.FC = () => {
  return (
    <div className="museum-container pb-20 pt-8 relative">
      
      <div className="h-64 md:h-80 w-full rounded-xl overflow-hidden mb-8">
        <Skeleton className="h-full w-full" />
      </div>
      
      <div className="bg-white p-6 rounded-xl shadow-sm mb-8">
        <Skeleton className="h-6 w-1/3 mb-4" />
        <Skeleton className="h-4 w-full mb-2" />
        <Skeleton className="h-4 w-full mb-2" />
        <Skeleton className="h-4 w-2/3" />
      </div>
      
      <div className="mb-8">
        <Skeleton className="h-6 w-1/4 mb-6" />
        <div className="space-y-4">
          {[1, 2, 3].map(i => (
            <Skeleton key={i} className="h-20 w-full" />
          ))}
        </div>
      </div>
    </div>
  );
};
